import { IExam, ISkill } from '../../../types'
import axios from '../../../helpers/axios'

export default {
  async create (context: IExam, payload: {name: string}): Promise<any> {
    const response = await axios().post(context.endpoints.skills, {skill: payload, exam_id: context.id})
    return response.data
  },

  async update (context: ISkill, payload: {name: string, id: number}): Promise<any> {
    const response = await axios().patch(context.endpoints.update, {skill: payload})
    return response.data
  },

  async destroy (context: ISkill): Promise<any> {
    const response = await axios().delete(context.endpoints.update)
    return response.data
  },

  async index (context: IExam): Promise<any> {
    const response = await axios().get(context.endpoints.skills)
    return response.data
  }
}
